import { useState } from 'react'
import { AdminAuthProvider, AdminAuthGate } from './components/AdminAuthProvider'
import { AdminLayout } from './AdminLayout'
import { UsersAdminView } from './users/UsersAdminView'
import BlogManagementView from './blog/BlogManagementView'
import BlogCoverLibraryView from './blog/BlogCoverLibraryView'
import BlogUploadPage from './blog/BlogUploadPage'
import { SkillsAdminView } from './skills/SkillsAdminView'
import '@/assets/styles/pages/admin.css'

// Persist admin page across potential re-mounts
let _lastAdminPage = 'users'

function AdminContent() {
  const [currentPage, setCurrentPage] = useState(() => _lastAdminPage)

  const handleNavigate = (page: string) => {
    _lastAdminPage = page
    setCurrentPage(page)
  }

  const renderPage = () => {
    switch (currentPage) {
      case 'users':
        return <UsersAdminView />
      case 'blog':
        return <BlogManagementView />
      case 'blog-covers':
        return <BlogCoverLibraryView />
      case 'blog-upload':
        return <BlogUploadPage />
      case 'skills':
        return <SkillsAdminView />
      default:
        return <UsersAdminView />
    }
  }

  return (
    <AdminLayout currentPage={currentPage} onNavigate={handleNavigate}>
      {renderPage()}
    </AdminLayout>
  )
}

export default function AdminShell() {
  return (
    <AdminAuthProvider>
      <AdminAuthGate>
        <AdminContent />
      </AdminAuthGate>
    </AdminAuthProvider>
  )
}
